/** 호버/모바일 안내 모달에서 본문보다 낮은 강조로 표시할 줄 (예시·안내·각주) */
export function isHoverMessageSecondaryLine(line: string): boolean {
  const trimmed = line.trim();
  return (
    (trimmed.startsWith('(') && trimmed.endsWith(')')) ||
    trimmed.startsWith('※') ||
    trimmed.startsWith('* ')
  );
}
